/**
 * The win meter's idle face (plan decision 43): while the game is idle and the plank shows no total, one-line tips
 * about the tumble, the cannon, the chance and the free spins take turns on it. A round holds the tip where it is; a
 * total flying in clears it. All on the chrome runner: real seconds, frozen by the dev pause.
 */
export interface WinMeterTipsTuning {
  /** The tips' localization keys (`game.<locale>.json`), in the order they take turns. */
  readonly keys: readonly string[];
  /** How long the game stays idle before a tip comes (so an autospin's next round never lets one in). */
  readonly idleDelaySeconds: number;
  /** How long each tip stays before the next. */
  readonly showSeconds: number;
  /** Each half of the cross-fade from one tip to the next (out, then in). */
  readonly fadeSeconds: number;
  /** The fade-out when a total is about to land on the plank. */
  readonly clearSeconds: number;
}

export const WIN_METER_TIPS_TUNING: WinMeterTipsTuning = {
  keys: ["tips.tumble", "tips.cannon", "tips.chance", "tips.free_spins"],
  idleDelaySeconds: 1,
  showSeconds: 4,
  fadeSeconds: 0.3,
  clearSeconds: 0.2,
};
